import assetPath from '/app/xinglets/upsell/products/src/assets/image-with-message-illustration-2.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')